import React from 'react';
import ColorTile from './ColorTile';

const ColorPalette = ({colors, selected, setColor, updateStyleColor, firstLetters}) => {

    const multicolor = {
        "id": 0,
        "name": "Multicolore",
        "hex": "000000",
        "contrast": "F5F5F5",
        "position": 13
    };

    return (
        <ul className='color-palette'>
            {
                colors?.map((color, index) => <ColorTile color={color} selected={parseInt(selected) === parseInt(color.id) ? true : false} setColor={setColor} key={index} updateStyleColor={updateStyleColor} firstLetters={false} />)
            }
            <ColorTile color={multicolor} selected={parseInt(selected) === 0} setColor={setColor} key={colors.length} updateStyleColor={updateStyleColor} firstLetters={firstLetters} />
        </ul>
    );
};

export default ColorPalette;